import React from 'react';
import { CouponTemplate } from '../../../components/coupon/CouponTemplate';
import { useNavigate } from 'react-router-dom';
import { Loading } from '../../../components/Loading';
import { Coupon } from '../../../models/coupon';
import { CustomerData } from '../../../models/customer';
import { useInitialCofig } from '../../../hooks/initialConfig-hook';
import { formatNumber, encodeURI } from '../../../utils/function-utils';

//AVCDAAV.002  20/03/2025  Add code for Adding coupon redeem page

type Props = {
    customerData?: CustomerData;
    couponRedeem?: Coupon[];
    loading: boolean;
};

const Redeem = (props: Props) => {
    const { initialConfig } = useInitialCofig();
    const navigate = useNavigate();



    function handleClickCoupon(key: string) {
        navigate(`/coupon/${encodeURI(key)}`);
    }


    if (props.loading) return (
        <div className='box-loading'>
            <Loading centered size='smallest' />
        </div>
    );

    return (
        <React.Fragment>
            <div className='redeem-point' style={{ ...initialConfig.styles.general_button_style, fontSize: "14px", backgroundColor: "transparent" }}>
                {formatNumber("en-US", props.customerData?.ramianing_point ?? 0)}<span className='unit'>&nbsp;Point</span>
            </div>
            <div className='coupon'>
                {props.couponRedeem?.sort((a: Coupon, b: Coupon) => b.points - a.points)
                    .map((item: Coupon, i: number) => (
                        <CouponTemplate
                            key={i}
                            couponData={item}
                            handleClickCoupon={() => handleClickCoupon(item.couponCode)}
                            // size='small'
                            size='large'
                        />
                    ))}
            </div>
        </React.Fragment>
    );
};

export default Redeem;

//C-AVCDAAV.002  20/03/2025  Add code for Adding coupon redeem page